'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _InlineVideoEditor = require('./components/InlineVideoEditor');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InlineVideoEditor).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-ugc-editors/lib/components/inline-video-editor/index.js
// module id = 1523
// module chunks = 1